var React = require('react');

function ArrowTopRightBlack (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.14403 1.55259L0.663692 1.55259L0.663692 0L11.7003 0L11.7003 11.4504H10.2038L10.2038 2.64875L1.19099 11.9995L0.132812 10.9016L9.14403 1.55259Z","fill":"#101010"}));
}

ArrowTopRightBlack.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = ArrowTopRightBlack;

ArrowTopRightBlack.default = ArrowTopRightBlack;
